export enum CodeTarget {
  GLOBAL = 'GLOBAL',
  SINGLE_PLACE = 'SINGLE_PLACE',
  SINGLE_CITY = 'SINGLE_CITY',
  NEW_ACCOUNT = 'NEW_ACCOUNT',
}
